export default __webpack_public_path__ + "static/media/pgmico(15).811512c5.png";